/**
 *  BombPowerup
 *
 *  Created by Legman on 02/05/2017.
 *
 */

import Bomb from "./Bomb";
import Common from "../Common";
import Powerup from "./Powerup";

/**
 * @class
 * @extends Powerup
 */
export default class BombPowerup extends Powerup {
    /**
     * @param {RaceCar} collector
     */
    constructor(collector) {
        super(collector);

        /**
         * @member {number}
         */
        this.launchDistance = 11;

        /**
         * @member {number}
         */
        this.launchHeight = 300;

        /**
         * @member {number}
         */
        this.launchDuration = 0.6;
    }

    /**
     * @param {number} dt
     */
    update(dt) {
        super.update(dt);
        if (this._bomb && this._bomb.destroyNextFrame) {
            this.destroyNextFrame = true;
        }
    }

    /**
     * @returns {boolean}
     */
    activate() {
        const activated = super.activate();
        if (activated) {
            this._bomb = this._createBomb();
            this._bomb.powerupType = this.type;
            this._bomb.offset.x = this._collector.offset.x;
            this._bomb.offset.y = -120;
            this._bomb.moving = true;
            this._bomb.lap = this._collector.lap;
            this._bomb.zDepthOffset = 1;
            this._collector.engine.addEntity(this._bomb, this._collector.distance + 1, false);

            delay(function() {
                this._collector.usingPowerup = false;
            }, 1, this);

            const tl = new TimelineMax({
                onComplete: function() {
                    this._bomb.arm();
                },
                onCompleteScope: this
            });

            tl.insert(TweenMax.to(this._bomb, this.launchDuration, {
                distance: this._bomb.distance + Math.max(0, this.launchDistance),
                ease: Power1.easeOut
            }));
            tl.insert(TweenMax.to(this._bomb.offset, this.launchDuration * 0.5, {
                y: this._bomb.offset.y - Math.max(0, this.launchHeight),
                ease: Power1.easeOut,
                yoyo: true,
                repeat: 1
            }));

            this._playSound();
        }
        return activated;
    }

    /**
     * @returns {Bomb}
     * @protected
     */
    _createBomb() {
        return new Bomb(this._collector);
    }

    _playSound() {
        Common.audio.playSound(["sfx_launch_object_00", "sfx_launch_object_01", "sfx_launch_object_02",
            "sfx_launch_object_03", "sfx_launch_object_04", "sfx_launch_object_05"]);
    }

    /**
     * @returns {Bomb}
     */
    get bomb() {
        return this._bomb;
    }
}